"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _UserContext = _interopRequireDefault(require("@micado-digital/react-ui/context/UserContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useIsLoggedIn = () => {
  const userData = (0, _react.useContext)(_UserContext.default)[0];
  const {
    _loading = false
  } = userData || {};
  const [isLoggedIn, setIsLoggedIn] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (_loading) return;
    setIsLoggedIn(!(0, _isEmpty.default)(userData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(userData)]);
  return isLoggedIn;
};
var _default = exports.default = useIsLoggedIn;